<template>
    <Modal :show-modal="$store?.modals.rateModal || false" @cancel="closeModal">
        <template v-slot:header>
            <p class="text-3xl font-bold text-main-color">{{ $t('page.rate') }}</p>
        </template>
        <template v-slot:content>
            <div class="flex flex-col">
                <div class="mx-auto my-2">

                    <VueStarRating :rounded-corners="true" :star-size="30" active-color="#ffb300"
                                inactive-color="#f2f2f2" :border-width="2" border-color="#ffb300" :show-rating="false"
                                :increment="1" v-model:rating="formRate.rating"></VueStarRating>
                </div>
                <div class="mt-5 flex gap-5">
                    <SubmitBtn @onclick="postRate" type="submit" :loading="loading">{{ $t('action.send') }}</SubmitBtn>
                    <button @click="closeModal" class="w-full text-main-color font-bold">{{ $t('action.cancel') }}</button>
                </div>
            </div>

        </template>
    </Modal>
</template>

<script>
import api from '@/api';
import { i18n } from '@/i18n'
import { reportPublicationSchema } from '@/schemas'
import { Field, Form, ErrorMessage } from 'vee-validate';
import Modal from '@cmp/Modal.vue'
import VueStarRating from 'vue-star-rating'


export default{
    components: {
        Modal,
        Field, 
        Form, 
        ErrorMessage,
        VueStarRating
    },
    props: {
        itemId: null,
        origin: 'product',

    },
    data(){
        return { 
            loading: false,
            formRate: {
                rating: 0
            },
            reportPublicationSchema: reportPublicationSchema,
            rateOriginUrls: {
                'media': 'posts/videos/',
                'product': 'mall/products/',
                'exhibition': 'exhibition/products/',
                'publication': 'publications/publications/'
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.modals.rateModal = false
        },
        async postRate() {
            this.loading = true
            try {
                const response = await api.post(`${this.rateOriginUrls[this.origin]}${this.itemId}/rate/`, this.formRate)
                this.$toast.info(`${i18n.global.t('warning.PUBLICATION_RATED')}`)
                this.$emit('rated', response.data.rating)
                this.closeModal()
                
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },

    }
}
</script>